import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import clsx from 'clsx';

import _ from 'lodash';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import BobConfirmButton from '../../../../components/BobConfirmButton';
import BobCancelButton from '../../../../components/BobCancelButton';
import BobLoadingMask from '../../../../components/BobLoadingMask';

import * as BobActions from '../../../../actions/bobActions';
import * as BasAgentActions from '../../../../actions/basAgentActions';

import * as parentClasses from './ConfigureAgentPage.module.css';
import * as classes from './ConfigureNiagaraPage.module.css';

const ValidationSchema = Yup.object().shape({
    apduRetries: Yup.number().typeError('Please input a number')
        .required(),
    apduSegmentTimeout: Yup.number().typeError('Please input a number')
        .required(),
    apduTimeout: Yup.number().typeError('Please input a number')
        .required(),
    bbmdIpAddress: Yup.string().matches(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, 'Invalid IP Address')
        .required(),
    bbmdUdpPort: Yup.number().typeError('Please input a number')
        .required(),
    betaDriver: Yup.boolean()
        .required(),
    bacNetDeviceId: Yup.number().typeError('Please input a number')
        .required(),
    disableReadMultiple: Yup.boolean()
        .required(),
    basAgentUdpPort: Yup.number().typeError('Please input a number')
        .required(),
    readQueueSize: Yup.number().typeError('Please input a number')
        .required(),
    whoisTimeout: Yup.number().min(10, 'Minimum WHOIS timeout is 10')
        .typeError('Please input a number')
        .required(),
    subnetMask: Yup.string().matches(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, 'Invalid IP Address')
        .required()
});

const DEFAULT_FORM_VALUES = {
    apduRetries:         3,
    apduSegmentTimeout:  6000,
    apduTimeout:         6000,
    bbmdIpAddress:       '',
    bbmdUdpPort:         47808,
    betaDriver:          false,
    bacNetDeviceId:      '',
    disableReadMultiple: false,
    basAgentUdpPort:     '47808',
    readQueueSize:       10,
    whoisTimeout:        60,
    subnetMask:          '255.255.255.0'
};

const ConfigureBacnetPage = ({
    activeNavCompany,
    fetchBasAgent,
    history,
    selectedAgent,
    setBobLoading,
    setSelectedAgent,
    updateBasAgent,
    bobLoading,
    ...props
}) => {
    const [initialValues, setInitialValues] = useState({ ...DEFAULT_FORM_VALUES });

    useEffect(() => {
        if (selectedAgent) {
            const driverConfig = _.find(selectedAgent.driverConfiguration, driver => driver.basType === 'BacnetIP');

            if (_.isNil(driverConfig)) return;

            const connection = _.get(driverConfig, 'connection', {});

            if (_.isEmpty(connection)) return;

            const formObject = { ...DEFAULT_FORM_VALUES };

            formObject.apduRetries = _.get(connection, 'apdU_Retries', 3);
            formObject.apduSegmentTimeout = _.get(connection, 'apdU_SegmentTimeout', 6000);
            formObject.apduTimeout = _.get(connection, 'apdU_Timeout', 6000);
            formObject.bbmdIpAddress = _.get(connection, 'bbmdHost', '');
            formObject.bbmdUdpPort = _.get(connection, 'bbmdPort', 47808);
            formObject.betaDriver = _.get(connection, 'polarSoft', false);
            formObject.bacNetDeviceId = _.get(connection, 'deviceId', '');
            formObject.disableReadMultiple = _.get(connection, 'disableReadMultiple', false);
            formObject.basAgentUdpPort = _.get(connection, 'port', 47808);
            formObject.readQueueSize = _.get(connection, 'readQueueSize', 10);
            formObject.whoisTimeout = _.get(connection, 'whoisTimeout', 30);
            formObject.subnetMask = _.get(connection, 'subnetMask', '255.255.255.0') || '255.255.255.0';

            setInitialValues(formObject);
        }
    }, [selectedAgent]);

    const formik = useFormik({
        initialValues:      initialValues,
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            const payload = {
                basType:    'BacnetIP',
                connection: {
                    apdU_Retries:        values.apduRetries,
                    apdU_SegmentTimeout: values.apduSegmentTimeout,
                    apdU_Timeout:        values.apduTimeout,
                    bbmdHost:            values.bbmdIpAddress,
                    bbmdPort:            values.bbmdUdpPort,
                    polarSoft:           values.betaDriver,
                    deviceId:            values.bacNetDeviceId,
                    disableReadMultiple: values.disableReadMultiple,
                    port:                values.basAgentUdpPort,
                    readQueueSize:       values.readQueueSize,
                    whoisTimeout:        values.whoisTimeout,
                    subnetMask:          values.subnetMask,
                    host:                null
                },
                gatewayDBFile: {
                    data: null,
                    name: null
                }
            };

            let driverConfig = _.find(selectedAgent.driverConfiguration, driver => driver.basType === 'BacnetIP');

            if (driverConfig) {
                payload.id = driverConfig.id;
            } else {
                driverConfig = _.find(selectedAgent.driverConfiguration, driver => driver.basType === 'NotConfigured');

                if (driverConfig) payload.id = driverConfig.id;
            }

            const updatedAgent = {
                driverConfiguration: [payload]
            };

            setSubmitting(true);

            try {
                setBobLoading('UpdateBasAgent');
                await updateBasAgent(activeNavCompany.id, selectedAgent.id, updatedAgent);
                const agent = await fetchBasAgent(selectedAgent.id);
                setSelectedAgent(agent);
                setSubmitting(true);
                setBobLoading('UpdateBasAgent');
                handleReroute();
            } catch (error) {

                setBobLoading('UpdateBasAgent');
                setSubmitting(false);
            }
        }
    });

    const handleReroute = () => {
        const path = '/v2/dashboard/iothub/manage';

        history.push({ pathname: path, search: history.location.search });
    };

    return (
        <React.Fragment>
            <div className={classes.InfoSettings}>
                <div className={classes.Title}>
                    BAS Agent BACnet Settings
                </div>
                <div className={classes.InfoPanel}>
                    <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                    <span className={classes.InfoText}>
                        <p>
                            The BAS Agent BACnet Settings are for setting up the BAS Agent as a BACnet device on the BACnet network for the BAS you are connecting to.
                        </p>
                    </span>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="bacNetDeviceId"
                                name="bacNetDeviceId"
                                label={<span>BAS Agent BACnet Device ID<span className={classes.Required}> *</span></span>}
                                placeholder="Enter"
                                value={formik.values.bacNetDeviceId}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.bacNetDeviceId) && Boolean(formik.touched.bacNetDeviceId)}
                                helperText={Boolean(formik.touched.bacNetDeviceId) && formik.errors.bacNetDeviceId}
                            />
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="basAgentUdpPort"
                                name="basAgentUdpPort"
                                label={<span>BAS Agent UDP Port<span className={classes.Required}> *</span></span>}
                                placeholder="Enter"
                                value={formik.values.basAgentUdpPort}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.basAgentUdpPort) && Boolean(formik.touched.basAgentUdpPort)}
                                helperText={Boolean(formik.touched.basAgentUdpPort) && formik.errors.basAgentUdpPort}
                            />
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="subnetMask"
                                name="subnetMask"
                                label={<span>Subnet Mask<span className={classes.Required}> *</span></span>}
                                placeholder="Enter"
                                value={formik.values.subnetMask}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.subnetMask) && Boolean(formik.touched.subnetMask)}
                                helperText={Boolean(formik.touched.subnetMask) && formik.errors.subnetMask}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
            <div className={classes.InfoCredentials}>
                <div className={classes.Title}>
                    BACnet Network BBMD Settings
                </div>
                <div className={classes.InfoPanel}>
                    <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                    <span className={classes.InfoText}>
                        <p>
                            The BACnet Network BBMD Settings are only needed if the BAS Agent will be connecting via a BBMD to gain access to the BAS BACnet network.
                        </p>
                    </span>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="bbmdIpAddress"
                                name="bbmdIpAddress"
                                label={<span>BBMD IP Address</span>}
                                placeholder="Enter"
                                value={formik.values.bbmdIpAddress}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.bbmdIpAddress) && Boolean(formik.touched.bbmdIpAddress)}
                                helperText={Boolean(formik.touched.bbmdIpAddress) && formik.errors.bbmdIpAddress}
                            />
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="bbmdUdpPort"
                                name="bbmdUdpPort"
                                label={<span>BBMD UDP Port</span>}
                                placeholder="Enter"
                                value={formik.values.bbmdUdpPort}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.bbmdUdpPort) && Boolean(formik.touched.bbmdUdpPort)}
                                helperText={Boolean(formik.touched.bbmdUdpPort) && formik.errors.bbmdUdpPort}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
            <div className={classes.InfoSecurity}>
                <div className={classes.Title}>
                    BACnet Advanced Settings
                </div>
                <div className={classes.InfoPanel}>
                    <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                    <span className={classes.InfoText}>
                        <p>
                            The BACnet Advanced Settings should remain at default values unless the BACnet network requires different values.
                        </p>
                    </span>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="apduTimeout"
                                name="apduTimeout"
                                label={<span>APDU Timeout (ms)</span>}
                                placeholder="Enter"
                                value={formik.values.apduTimeout}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.apduTimeout) && Boolean(formik.touched.apduTimeout)}
                                helperText={Boolean(formik.touched.apduTimeout) && formik.errors.apduTimeout}
                            />
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="apduSegmentTimeout"
                                name="apduSegmentTimeout"
                                label={<span>APDU Segment Timeout (ms)</span>}
                                placeholder="Enter"
                                value={formik.values.apduSegmentTimeout}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.apduSegmentTimeout) && Boolean(formik.touched.apduSegmentTimeout)}
                                helperText={Boolean(formik.touched.apduSegmentTimeout) && formik.errors.apduSegmentTimeout}
                            />
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="apduRetries"
                                name="apduRetries"
                                label={<span>APDU Retries</span>}
                                placeholder="Enter"
                                value={formik.values.apduRetries}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.apduRetries) && Boolean(formik.touched.apduRetries)}
                                helperText={Boolean(formik.touched.apduRetries) && formik.errors.apduRetries}
                            />
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="whoisTimeout"
                                name="whoisTimeout"
                                label={<span>WHOIS Timeout (s)</span>}
                                placeholder="Enter"
                                value={formik.values.whoisTimeout}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.whoisTimeout) && Boolean(formik.touched.whoisTimeout)}
                                helperText={Boolean(formik.touched.whoisTimeout) && formik.errors.whoisTimeout}
                            />
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="readQueueSize"
                                name="readQueueSize"
                                label={<span>Read Queue Size</span>}
                                placeholder="Enter"
                                value={formik.values.readQueueSize}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.readQueueSize) && Boolean(formik.touched.readQueueSize)}
                                helperText={Boolean(formik.touched.readQueueSize) && formik.errors.readQueueSize}
                            />
                        </FormControl>
                        <FormControl>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formik.values.betaDriver}
                                        value="betaDriver"
                                        name="betaDriver"
                                        color="primary"
                                        onChange={formik.handleChange}
                                    />
                                }
                                label={'Use Beta Driver'}
                                className={classes.checkboxLabel}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
            <div className={parentClasses.InfoButtons}>
                <span>
                    <BobCancelButton
                        onClick={handleReroute}
                        disabled={formik.isSubmitting}
                        className={classes.CancelButton}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        onClick={formik.handleSubmit}
                        disabled={formik.isSubmitting}
                        className={classes.SaveButton}
                        label={'Save'}
                        iconSize={15}
                    />
                </span>
            </div>
            {
                bobLoading.includes('UpdateBasAgent') ?
                    <BobLoadingMask />
                    :
                    null
            }
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    bobLoading: state.bob.bobLoading
});

const mapDispatchToProps = {
    ...BasAgentActions,
    ...BobActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfigureBacnetPage));
